// Duration helpers for estimated_duration strings ("30 min", "1h 15m", "2 timmar").
// Used to sum course times into a program total, and to render the total back.

/** Best-effort parse of a duration string → total minutes. */
export const parseMinutes = (s?: string): number => {
    if (!s) return 0;
    const lower = s.toLowerCase();
    const h = lower.match(/(\d+)\s*(h|tim)/);
    const m = lower.match(/(\d+)\s*(m|min)/);
    let total = 0;
    if (h) total += parseInt(h[1], 10) * 60;
    if (m) total += parseInt(m[1], 10);
    if (!h && !m) {
        const n = lower.match(/\d+/); // bare number → assume minutes
        if (n) total += parseInt(n[0], 10);
    }
    return total;
};

/** Format total minutes → "X min" / "Xh Ym". Empty string for 0. */
export const formatMinutes = (min: number): string => {
    if (min <= 0) return '';
    if (min < 60) return `${min} min`;
    const h = Math.floor(min / 60);
    const m = min % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
};

/** Sum a list of duration strings → total minutes. */
export const sumMinutes = (durations: (string | undefined)[]): number =>
    durations.reduce((sum, d) => sum + parseMinutes(d), 0);
